import 'babel-polyfill'
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
//import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import i18n from './locale/i18n'
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false

Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VueAxios, axios)

/*
if(process.env.NODE_ENV === 'production'){
}
*/

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
